module.exports = __webpack_public_path__ + "img/海军工程大学.25f52f0e.png";